export default "__VITE_ASSET__wRWuKyDH__"